// Team (2026-10-07): which playbook a conversation is worked under, Customer
// Service or Support. Separate from `client`, which means the order's
// marketplace (Website / eBay / Amazon). Flows, spam rules, templates and CSR
// visibility are keyed on the EFFECTIVE team: an admin's override (or a
// Transfer to Support) wins over the team the mailbox gave it. The Support
// MAILBOX's own rules are not, and since 2026-10-12 they are not a team
// property at all: supportMailboxRulesApply() in server/src/companies.js reads
// the account's rulesProfile. See docs/decisions.md (2026-10-07, 2026-10-09,
// 2026-10-12).

export const TEAMS = ['customer_service', 'support']

export const TEAM_LABELS = {
  customer_service: 'Customer Service',
  support: 'Support',
}

export function teamLabel(team) {
  return TEAM_LABELS[team] ?? team
}

export function isTeam(value) {
  return TEAMS.includes(value)
}

// The one rule for a conversation's team: the override, else the team its
// mailbox gave it at ingest.
export function effectiveTeam(conversation) {
  return conversation?.teamOverride ?? conversation?.team ?? 'customer_service'
}


// For team Support, client is the order's marketplace, from its TRQ client
// code. null when the code names none (the mailbox's own client applies).
export const MARKETPLACE_CLIENT_BY_TRQ_CODE = {
  '1AW': 'Website', 'AMW': 'Website',
  '1AE': 'eBay', 'AME': 'eBay',
  '1AA': 'Amazon', 'AMA': 'Amazon',
  // Walmart Marketplace (2026-10-14), 1A only.
  'WMT': 'Walmart',
}

export function marketplaceClientFor(trqClientCode) {
  return MARKETPLACE_CLIENT_BY_TRQ_CODE[trqClientCode] ?? null
}

// The team a template folder tree belongs to when none is given: the Support
// trees ("1A Support/…", "AM Support/…") are Support, everything else Customer
// Service — the same rule migration 0099 backfilled with.
export function teamForFolder(folder) {
  return /^(1A|AM) Support\//.test(folder ?? '') ? 'support' : 'customer_service'
}

// A template row's team: its own column, else its folder tree's (a row from
// before migration 0099, or a test fixture, carries none).
export function templateTeam(template) {
  return template?.team ?? teamForFolder(template?.folder)
}
